import { Box, useTheme } from '@mui/material';
import { AssetWrapper } from '../../assetComponents/assetWrapper/AssetWrapper';
import { BaseAssetProps } from '../../assetComponents/types';
import { useEffect, useState } from 'react';
import { DASHBOARD_TEST_LABELS } from 'src/features/customDashboard/constants';

type Props = BaseAssetProps;

export const Rectangle = ({ width, height, selected, data, id }: Props) => {
  const [dimensions, setDimensions] = useState({
    width: data?.width ?? width ?? 200,
    height: data?.height ?? height ?? 200,
  });

  const theme = useTheme();

  const greyColor = theme.palette.grey[500];

  useEffect(() => {
    if (data?.width || data?.height) {
      setDimensions({
        width: data.width ? Number(data.width) : dimensions.width,
        height: data.height ? Number(data.height) : dimensions.height,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.width, data?.height]);

  useEffect(() => {
    if (width || height) {
      setDimensions({
        width: width ?? dimensions.width,
        height: height ?? dimensions.height,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width, height]);

  return (
    <AssetWrapper id={id} selected={selected} width={dimensions.width} height={dimensions.height}>
      <Box
        sx={{
          background: data?.fillColor || greyColor,
          border: data?.strokeColor
            ? `${data?.strokeThickness || '0px'} solid ${data.strokeColor}`
            : 'none',
          width: dimensions.width,
          height: dimensions.height,
        }}
        data-sm={DASHBOARD_TEST_LABELS.RECTANGLE}
      />
    </AssetWrapper>
  );
};
